import { PortalProvider } from "@gorhom/portal";
import React, { FC, JSX } from "react";
import { StatusBar, StyleSheet } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { Notifications } from "@lookiero/sty-psp-notifications";
import { theme } from "@lookiero/sty-psp-ui";
import { MESSAGING_CONTEXT_ID } from "../../delivery/baseBootstrap";
import { DOMAIN } from "../i18n/i18n";

const SCREEN_MODAL_Z_INDEX = 100;

const style = StyleSheet.create({
  toast: {
    zIndex: SCREEN_MODAL_Z_INDEX + 1,
  },
});

const notificationsStyle = { toast: style.toast };

interface AppProps {
  readonly children: JSX.Element;
}

const App: FC<AppProps> = ({ children }) => {
  const { colorBgBase } = theme();

  return (
    <SafeAreaProvider>
      <PortalProvider rootHostName="StyleProfile">
        <StatusBar backgroundColor={colorBgBase} barStyle="dark-content" translucent />
        <Notifications
          contextId={MESSAGING_CONTEXT_ID}
          domain={DOMAIN}
          portalHostName="StyleProfile"
          style={notificationsStyle}
        />
        {children}
      </PortalProvider>
    </SafeAreaProvider>
  );
};
export { App };
